import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$9 = ".VisuallyHidden_module_hidden__c5a4c7ad,:not(:focus):not(:focus-within) .VisuallyHidden_module_focusable__c5a4c7ad{border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);white-space:nowrap;word-wrap:normal}";
collectCss(css$9);
var modules_b0018d5a = {"focusable":"VisuallyHidden_module_focusable__c5a4c7ad","hidden":"VisuallyHidden_module_hidden__c5a4c7ad"};

export { css$9 as css, modules_b0018d5a as default };
//# sourceMappingURL=VisuallyHidden.module.css.mjs.map
